import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import { Observable } from 'rxjs/Rx';
import { environment } from '../../environments/environment';
import { cacheable, clearCache, headers, headersBlob } from '../util/rxjs-functions';
import { bObservableUsuario } from '../util/observable-util';

@Injectable()
export class PadraoService {

  constructor(public http: Http, private bObservable: bObservableUsuario) { }

  LimparCache = (key: string) => clearCache(key);

  Adicionar(route: string, obj: any): Observable<any> {
    return this.http.post(`${environment.apiEndpoint}/${route}`, obj, headers()).map(res => <any>res.json());
  }
  Atualizar(route: string, obj: any, parcial?: any): Observable<any> {
    return this.http.put(`${environment.apiEndpoint}/${route}`, obj, headers(parcial)).map(res => <any>res.json());
  }
  Deletar(route: string, id: number): Observable<any> {
    return this.http.delete(`${environment.apiEndpoint}/${route}/${id}`, headers()).map(res => <any>res.json());
  }
  Retornar(route: string, obj: any): Observable<any> {
    return this.http.put(`${environment.apiEndpoint}/${route}/retornar`, obj, headers()).map(res => <any>res.json());
  }
  Indeferir(route: string, obj: any): Observable<any> {
    return this.http.put(`${environment.apiEndpoint}/${route}/indeferir`, obj, headers()).map(res => <any>res.json());
  }
  Deferir(route: string, obj: any): Observable<any> {
    return this.http.put(`${environment.apiEndpoint}/${route}/deferir`, obj, headers()).map(res => <any>res.json());
  }
  darBaixa(route: string, obj: any): Observable<any> {
    return this.http.put(`${environment.apiEndpoint}/${route}/darbaixa`, obj, headers()).map(res => <any>res.json());
  }
  cancelarRegistro(route: string, obj: any): Observable<any> {
    return this.http.put(`${environment.apiEndpoint}/${route}/cancelar`, obj, headers()).map(res => <any>res.json());
  }
  restabelecerRegistro(route: string, obj: any): Observable<any> {
    return this.http.put(`${environment.apiEndpoint}/${route}/restabelecer`, obj, headers()).map(res => <any>res.json());
  }
  Obter = (route: string, id: number, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${id}`, headers()).map((res: Response) => <any>res.json()),
    cacheKey,
    refresh
  )
  ObterRequerimento = (route: string, filtro?: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}`, headers(filtro)).map((res: Response) => <any>res.json()),
    cacheKey,
    refresh
  )
  ObterLogoLotacao = (route: string, id: string, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${id}`, headers()).map((res: Response) => <any>res.json()),
    cacheKey,
    refresh
  )

  ObterLogoCfc = (cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/acessos/obterLogoCfc`, headers()).map((res: Response) => <any>res.json()),
    cacheKey,
    refresh
  )
  ObterCep = (route: string, id: string, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${id}`, headers()).map((res: Response) => <any>res.json()),
    cacheKey,
    refresh
  )
  ServicoDuplicado(route: string, obj: any): Observable<any>{
    return this.http.get(`${environment.apiEndpoint}/${route}/servicoDuplicado`, headers(obj)).map((res: Response) => <any[]>res.json());
  }

  EnviarSolicitacao(route: string, obj: any): Observable<any> {
    return this.http.post(`${environment.apiEndpoint}/${route}/enviar`, obj, headers()).map(res => <any>res.json());
  }

  Enviar(route: string, obj: any): Observable<any> {
    return this.http.put(`${environment.apiEndpoint}/${route}/enviar`, obj, headers()).map(res => <any>res.json());
  }

  Assinar(route: string, obj: any): Observable<any> {
    return this.http.post(`${environment.apiEndpoint}/${route}/assinar`, obj, headers()).map(res => <any>res.json());
  }

  CancelarSolicitacao(route: string, obj: any): Observable<any> {
    return this.http.post(`${environment.apiEndpoint}/${route}/cancelar`, obj, headers()).map(res => <any>res.json());
  }

  ConsultarServico(route: string, obj: any): Observable<any> {
    return this.http.get(`${environment.apiEndpoint}/${route}/consultaServico`,
      headers(obj)).map(res => <any>res.json());
  }
  /**
   * método de obter sem a rota padrao, ou seja a rota completa tem que ser passada na assinatura.
   * @param route 
   * @param key 
   */
  obterGenerico(route: string, key: any): Observable<any> {
    return this.http.get(`${environment.apiEndpoint}/${route}/${key}`, headers()).map(res => <any>res.json());
  }

  ListarTodosUsuarios = (route: string, filtro?: any, filtro2?: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/obterUsuarios/${filtro}/${filtro2}`, headers()).map((res: Response) => <any[]>res.json()),
    cacheKey,
    refresh
  )
  obterPor(route: string, key: any): Observable<any> {
    return this.http.get(`${environment.apiEndpoint}/${route}/obterPor/${key}`, headers()).map(res => <any>res.json());
  }

  obterPjSemSolicitacaoPendente(route: string, key: any): Observable<any> {
    return this.http.get(`${environment.apiEndpoint}/${route}/obterPjSemSolicitacaoPendente/${key}`, headers()).map(res => <any>res.json());
  }

  obterPessoaCnaiPor(route: string, key: any): Observable<any> {
    return this.http.get(`${environment.apiEndpoint}/${route}/obterPessoaCnaiPor/${key}`, headers()).map(res => <any>res.json());
  }
  preCadastroVerify(route: string, key: any): Observable<any> {
    return this.http.get(`${environment.apiEndpoint}/${route}/preCadastroVerify/${key}`, headers()).map((res: Response) => <any>res.json());
  }
  ObterAnexo = (route: string, id: number, key: string, classtype: string, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${classtype}/${id}/${key}`, headers()).map((res: Response) => <any>res.json()),
    cacheKey,
    refresh
  )
  ObterCodigo = (route: string, filtro?: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/codigo`, headers(filtro)).map((res: Response) => <any[]>res.json()),
    cacheKey,
    refresh
  )
  ListarTodos = (route: string, filtro?: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/listarTodos`, headers(filtro)).map((res: Response) => <any[]>res.json()),
    cacheKey,
    refresh
  )

  ObterComInclude = (route: string, filtro?: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/obter`, headers(filtro)).map((res: Response) => <any>res.json()),
    cacheKey,
    refresh
  )

  ListarRegistros = (route: string, filtro?: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}`, headers(filtro)).map((res: Response) => <any[]>res.json()),
    cacheKey,
    refresh
  )

  ListarTodasDelegaciasPorCidade = (route: string, lotacao: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/listarTodasDelegaciasPorCidade/${lotacao}`, headers()).map((res: Response) => <any[]>res.json()),
    cacheKey,
    refresh
  )
  ObterTodos = (route: string, filtro?: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}`, headers(filtro)).map((res: Response) => <any[]>res.json()),
    cacheKey,
    refresh
  )

  ObterSocios(route: string, id: number): Observable<any> {
    return this.http.get(`${environment.apiEndpoint}/${route}/obterSocios/${id}`, headers()).map(res => <any>res.json());
  }

  Filtro = (route: string, filtro: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}`, headers(filtro)).map((res: Response) => <any[]>res.json()),
    cacheKey,
    refresh
  )

  ExecutarMetodo(route: string, obj: any, tipo: string): Observable<any> {

    switch (tipo) {
      case "POST":
        return this.http.post(`${environment.apiEndpoint}/${route}`, obj, headers()).map(res => <any>res.json());

      case "GET":
        return this.http.get(`${environment.apiEndpoint}/${route}`, obj).map(res => <any>res.json());

      case "PUT":
        return this.http.put(`${environment.apiEndpoint}/${route}`, obj, headers()).map(res => <any>res.json());

      case "DELETE":
        return this.http.delete(`${environment.apiEndpoint}/${route}`, obj).map(res => <any>res.json());
    }
  }

  Relatorio = (route: string, value?: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${value != undefined && value != '0' ? value : ''}`, headersBlob())
      .map((res) => res),
    cacheKey,
    refresh
  )

  GerarCertidaoCnaipj = (route: string, value?: any, filtro?: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${value != undefined && value != '0' ? value : ''}`, filtro ? headersBlob(filtro) : headersBlob())
      .map((res) => res),
    cacheKey,
    refresh
  )

  GerarCertidao = (route: string, value?: any, lotacao?: number, filtro?: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${value != undefined && value != '0' ? value : ''}/${lotacao}`, filtro ? headersBlob(filtro) : headersBlob())
      .map((res) => res),
    cacheKey,
    refresh
  )

  /**
   * Parte de auth abaixo:
   */
  Permissoes = (refresh: boolean = true) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/api/Autenticar/permissao`, headers()).map(res => {
      this.bObservable.setValue({ obj: res.json() });
      return res.json();
    }).catch(this.handleAuthError),
    localStorage.getItem('token'),
    refresh
  );
  ObterToken = (code: string, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.post(`${environment.apiEndpoint}/api/Autenticar/Token/${code}`, null).map(res => <any>res.json()),
    cacheKey,
    refresh
  )
  ObterTokenDecodificado = (refresh: boolean = true) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/api/Autenticar/DecodeToken`, headers()).map(res => {
      return res.json();
    }),
    localStorage.getItem('token'),
    refresh
  );
  Logout = () => this.http.get(`${environment.apiEndpoint}/api/Autenticar/sair`, headers()).subscribe(() => {
    localStorage.clear();
    location.reload();
  });

  Lotacoes = (refresh: boolean = true) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/api/Autenticar/lotacao`, headers()).map(res => {
      return res.json();
    }),
    localStorage.getItem('token'),
    refresh
  );

  ObterBoleto = (route: string, id: number, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${id}`, headers()).map((res: Response) => <any>res.json()),
    cacheKey,
    refresh
  )
  EnviarEmail = (route: string, id: number, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${id}`, headers()).map((res: Response) => <any>res.json()),
    cacheKey,
    refresh
  )

  ObterRequerimentoPF = (route: string, id: number, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}/${id}`, headersBlob()).map((res) => res),
    cacheKey,
    refresh
  )

  ObterRequerimentoServico = (route: string, filtro: any, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}`, headersBlob(filtro)).map((res) => res),
    cacheKey,
    refresh
  )

  verificarAnexosPF(key: any, situacao: number): Observable<any> {
    return this.http.get(`${environment.apiEndpoint}/pessoaFisica/VerificarAnexos/${key}/${situacao}`, headers()).map(res => <any>res.json());
  }

  verificarAnexosPJ(key: any, situacao: number): Observable<any> {
    return this.http.get(`${environment.apiEndpoint}/pessoaJuridica/VerificarAnexos/${key}/${situacao}`, headers()).map(res => <any>res.json());
  }

  SimularUsuario = (cpf: string, cacheKey?: string, refresh: boolean = false) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/acessos/simularUsuario/${cpf}`, headers()).map((res: Response) => <any[]>res.json()),
    cacheKey,
    refresh
  )
  AtualizarSimularUsuario(cpf: string, parcial?: any): Observable<any> {
    return this.http.put(`${environment.apiEndpoint}/acessos/simularUsuario/${cpf}`, null, headers(parcial)).map(res => <any>res.json());
  }

  requisicaoManual(): Observable<any> {
    return this.http.get(`${environment.apiEndpoint}/manual/ajudaOnline`, headers()).map(response => response.json());
  }

  IsPrimeiraSolicitacao = (route: string) => cacheable(
    () => this.http.get(`${environment.apiEndpoint}/${route}`, headers()).map((res: Response) => <boolean>res.json())
  )

  private handleAuthError(erro: any): Observable<any> {
    if (erro.status === 403) {
      localStorage.removeItem("token");
      window.location.href = `${environment.apiEndpoint}/api/Autenticar/`;
      return Observable.of(false);
    }
    return Observable.throw(erro);
  }

}


// WEBPACK FOOTER //
// ./src/app/service/padrao.service.ts